<div class="modal-header">
  <h4 class="modal-title">Registrar Ausência Legal</h4>
  <button type="button" (click)="onDismiss()" class="close" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" tabindex="0" ngbAutofocus>
  <form class="form-horizontal" [formGroup]="form">
    <div class="form-group">
      <label class="form-control-label" for="dateBegin">Data do afastamento</label>
      <input
        type="date"
        id="dateBegin"
        formControlName="dateBegin"
        class="form-control"
        [attr.min]="minAbsenceDate"
        [attr.max]="maxAbsenceDate"
        (change)="onDateBeginChange()"
      />
      <small *ngIf="retroactiveDaysHint" class="text-muted d-block mt-1">{{ retroactiveDaysHint }}</small>
      <app-error-msg [control]="form.controls['dateBegin']" [label]="'Data do afastamento'"></app-error-msg>
    </div>

    <div class="form-group mb-0">
      <label class="form-control-label" for="excusedAbsenceDocument">Documento (PDF ou imagem)</label>
      <div class="custom-file">
        <input
          type="file"
          id="excusedAbsenceDocument"
          class="custom-file-input"
          accept=".pdf,.png,.jpg,.jpeg,image/*,application/pdf"
          (change)="handleFileInput($event)"
          [disabled]="uploadingFile || isLoading"
        />
        <label class="custom-file-label" for="excusedAbsenceDocument">
          {{ selectedFileName || 'Selecionar arquivo...' }}
        </label>
      </div>
      <small class="text-muted d-block mt-1">Formatos permitidos: PDF, PNG, JPG e JPEG.</small>
      <div *ngIf="uploadingFile" class="mt-1">
        <span class="spinner-border spinner-border-sm mr-1"></span>
        Enviando documento...
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onDismiss()" [disabled]="isLoading">
    Cancelar
  </button>
  <button
    type="button"
    class="btn btn-gradient-primary"
    (click)="handleSubmit()"
    [disabled]="isLoading || uploadingFile || form.invalid || !fileKey"
  >
    Salvar
    <span *ngIf="isLoading" class="spinner-border spinner-border-sm ml-1"></span>
  </button>
</div>
